import React, { useState, useEffect } from 'react';
import ContratoCuotaEditor from './ContratoCuotaEditor';
import { connect } from 'react-redux';
import {
  getAllByParent,
  setPending,
  deleted,
} from '../redux/actions/contratoCuotaActions';
import { get as getParent } from '../redux/actions/contratoActions';
import { callStatus } from '../utils/constants';
import { Button, Space, Layout, Modal, Tag } from 'antd';
import { withRouter } from 'react-router-dom';

import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import MetaTable from './base/MetaTable';
import dayjs from 'dayjs';
import { convertDate, formatNumber } from '../utils/funtions';
import StateIcon from './base/StateIcon';
import CustomCellRender from './base/CustomCellRender';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const ContratoCuotaList = ({
  stateData,
  inversor,
  dispatch,
  match,
  contratoId,
  parent,
  alquilerParent,
  contratoCuotaEstado,
  configuracion,
}) => {
  const isInversorUnico =
    configuracion?.list?.data?.find((c) => c.nombre === 'inversor_unico')
      ?.valor === '1';

  const id3 = contratoId || match.params.id3;
  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  useEffect(() => {
    dispatch(getAllByParent(id3));
    dispatch(getParent(id3));

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      dispatch(getAllByParent(id3));
    }
  }, [stateData.object.status, id3, dispatch]);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id)).then(() => {
      dispatch(getAllByParent(id3));
    });
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const isEfectivo = parent.object.data?.forma_pago_id === 1;

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 60,
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Estado',
      dataIndex: 'estado',
      onFilter: (value, record) => {
        return record.estado_id === value;
      },
      sorter: (a, b) => a.estado?.nombre?.localeCompare(b.estado?.nombre),
      filterMultiple: true,
      filters: contratoCuotaEstado.list.data.map((value) => {
        value['value'] = value.id;
        value['text'] = value.nombre;
        return value;
      }),
      render: (text) => (
        <>
          <StateIcon value={text?.nombre} />
          <span> {text?.nombre} </span>
        </>
      ),
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Número',
      dataIndex: 'numero',
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
      render: (text) =>
        text ? dayjs(convertDate(text)).format('DD/MM/YYYY') : '',
    },
    ...(!isInversorUnico
      ? [
          {
            title: 'Aportantes',
            dataIndex: 'inversores',
            render: (text, record) => {
              if (
                record.contrato_cuota_inversores &&
                record.contrato_cuota_inversores.length > 0
              ) {
                return (
                  <>
                    {record.contrato_cuota_inversores.map((inv) => (
                      <Tag color="blue" key={inv.inversor_id}>
                        {inv.inversor_nombre} ({inv.porcentaje}%)
                      </Tag>
                    ))}
                  </>
                );
              }
              return null;
            },
          },
        ]
      : []),

    {
      width: 150,
      ellipsis: true,
      title: isEfectivo ? 'Precio Cuota $' : 'Precio Soja $',
      dataIndex: 'precio',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    ...(isEfectivo
      ? []
      : [
          {
            width: 150,
            ellipsis: true,
            title: 'Toneladas',
            dataIndex: 'toneladas',
            render: (text) => (
              <CustomCellRender
                text={text}
                justify={'space-between'}
                prefix={''}
              />
            ),
          },
        ]),
    {
      width: 150,
      ellipsis: true,
      title: 'Dolar',
      dataIndex: 'dolar',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 150,
      ellipsis: true,
      title: 'Importe U$D',
      dataIndex: 'importe',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Comisión',
      dataIndex: 'comision',
    },
    {
      title: 'Total Final',
      render: (text, record) =>
        record.comision
          ? formatNumber(
              (
                parseFloat(record.importe) + parseFloat(record.comision)
              ).toFixed(3)
            )
          : formatNumber(parseFloat(record.importe).toFixed(3)),
      width: 150,
    },
  ];

  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={stateData.list.data}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar Cuota
            </Button>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <ContratoCuotaEditor
          id={rowEdit.id}
          parentId={id3}
          onCancel={handleHideEditor}
          numero={stateData.list.data.length + 1}
          visible={true}
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const {
    contratoCuota,
    inversor,
    contrato,
    contratoCuotaEstado,
    alquiler,
    configuracion,
  } = state;
  const stateData = contratoCuota;
  const parent = contrato;
  const alquilerParent = alquiler;

  return {
    stateData,
    inversor,
    parent,
    alquilerParent,
    contratoCuotaEstado,
    configuracion,
  };
};
export default connect(mapStateToProps)(withRouter(ContratoCuotaList));
